import {
  Component,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { debounceTime, Subject, Subscription } from 'rxjs';
import { ProformsAdminService } from '../../../../services/proforms/proforms-admin.service';
import {
  ProformFieldTypes,
  ProFormsAPIResponse,
  ProFormsQuestionAPIResponse,
} from '../../../../types/responses/proforms.responses';

@Component({
  selector: 'app-proforms-admin-question-answer-options',
  standalone: false,
  templateUrl: './proforms-admin-question-answer-options.component.html',
  styleUrl: './proforms-admin-question-answer-options.component.scss',
})
export class ProformsAdminQuestionAnswerOptionsComponent
  implements OnInit, OnChanges, OnDestroy
{
  @Input() question: ProFormsQuestionAPIResponse;

  subs: Subscription[] = [];

  isQuiz = false;

  FieldTypes = ProformFieldTypes;

  answerChangeSubject = new Subject<{ id: number; answer: string }>();

  constructor(private proformsAdminService: ProformsAdminService) {}

  ngOnInit() {
    this.answerChangeSubject
      .pipe(debounceTime(500))
      .subscribe(({ id, answer }) => {
        if (answer.trim() === '') return;
        this.updateAnswerOption(id, answer);
      });

    this.subs.push(
      this.proformsAdminService.currentProForm.subscribe((response) => {
        if (response) {
          const form: ProFormsAPIResponse = response;
          this.isQuiz = form.type === 'quiz';
        }
      })
    );
  }

  ngOnChanges(changes: SimpleChanges) {
    if (
      changes['question']?.isFirstChange() &&
      this.question?.answerOptions.length === 0 &&
      !this.question?.answerOptions.some((opt) => opt.answer === 'Option 1')
    ) {
      this.createAnswerOption('Option 1');
    }
  }

  onAnswerChange(optionId: number, title: string) {
    this.answerChangeSubject.next({ id: optionId, answer: title });
  }

  deleteAnswer(optionId: number) {
    const isTemporary = optionId < 0;
    this.question.answerOptions = this.question.answerOptions.filter(
      (opt) => opt.id !== optionId
    );

    if (!isTemporary) {
      this.proformsAdminService.deleteAnswerOption(optionId).subscribe();
    }
  }

  updateAnswerOption(optionId: number, answer: string) {
    this.proformsAdminService
      .updateAnswerOption(optionId, {
        answer,
      })
      .subscribe();
  }

  addAnswerOption() {
    const nextIndex = this.question.answerOptions.length + 1;
    const defaultAnswer = `Option ${nextIndex}`;
    this.createAnswerOption(defaultAnswer);
  }

  createAnswerOption(answer: string) {
    this.proformsAdminService
      .createAnswerOption(this.question.id, { answer })
      .subscribe((res) => {
        this.question.answerOptions.push({
          id: res.item.id,
          proform_form_id: res.item.proform_form_id,
          proform_form_question_id: res.item.proform_form_question_id,
          answer: res.item.answer,
          is_correct: 0,
          sort_order: this.question.answerOptions.length + 1000,
          next_section_override: '',
        });
      });
  }

  handleCheckedAnswer(optionId: number) {
    if (this.isQuiz && this.question.field_type === this.FieldTypes.RADIO) {
      // remove all other is_correct options
      this.question.answerOptions.forEach((opt) => {
        if (opt.id !== optionId) {
          if (opt.is_correct === 1) {
            this.proformsAdminService
              .updateCorrectAnswerOption(opt.id, {
                is_correct: 0,
              })
              .subscribe();
          }
        }
      });
    }
  }

  ngOnDestroy() {
    let sub = this.subs.pop();
    while (sub) {
      sub.unsubscribe();
      sub = this.subs.pop();
    }
  }
}
